import { render, staticRenderFns } from "./comparisonTable.vue?vue&type=template&id=711f5bf6&scoped=true&"
import script from "./comparisonTable.vue?vue&type=script&lang=js&"
export * from "./comparisonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711f5bf6",
  null
  
)

export default component.exports